export const CHART_MARGINS = {
  mobile: { top: 10, right: 20, bottom: 40, left: 50 },
  desktop: { top: 10, right: 100, bottom: 40, left: 140 },
};

export const CHART_HEIGHT = {
  xs: 240,
  md: 320,
};

export const HIDDEN_ON_MOBILE = {
  display: { xs: 'none', md: 'table-cell' },
};
